import React from "react"
import { ArrowLeftIcon } from '@heroicons/react/20/solid'

const PageNotFound = () => {
  return (
    <div className="flex flex-row">
      <div className="flex-row-left w-1/2 h-screen">
        <div className="pl-12 flex items-center justify-center mt-10 ">
          <div className="pl-12 w-full max-w-md mt-10">
            <p className="text-sm font-bold text-primary mt-10">404 ERROR</p>
            <h2 className="text-3xl font-bold tracking-tight text-gray-900">
              Page not found
            </h2>
            <p className="text-gray-600">
              Sorry, we couldn't find the page you're looking for.
            </p>            
            <div className="flex mt-4 font-medium text-primary hover:text-secondary">

            <ArrowLeftIcon className="h-6 w-7 "/>
              <a
                data-cke-saved-href="/"
                href="/"
                className="font-medium text-primary hover:text-secondary pl-2"
               >
                 Go back to home
                
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PageNotFound